import React, { useState } from 'react';
import Preloader from '../components/Preloader';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollReveal from '../components/ScrollReveal';

const Termsofservice = () => {
  const [activeTab, setActiveTab] = useState('terms');

  return (
    <div className='font-nixie-one bg-gray-50 min-h-screen text-gray-800'>
      <Header />
      <Preloader />
      <main>
        {/* Hero Section */}
        <section className="relative h-[40vh] md:h-[50vh] bg-cover bg-center" style={{ backgroundImage: "url('/assets/legal.jpg')" }}>
            <div className="absolute inset-0 bg-blue-900/80 flex items-center justify-center">
                <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                <div className="text-center text-white px-4">
                    <h1 className="text-2xl md:text-3xl font-bold mb-4 tracking-wide">Legal & Compliance</h1>
                    <p className="text-sm md:text-sm max-w-2xl mx-auto font-light">
                        Transparency, integrity, and trust are the foundations of our relationship with you.
                    </p>
                </div>
                </ScrollReveal>
            </div>
        </section>

        {/* Content Section */}
        <section className="py-16 px-4 container mx-auto max-w-5xl">
            {/* Tabs */}
            <div className="flex justify-center mb-12">
                <div className="bg-white p-1 rounded-full shadow-md inline-flex">
                    <button
                        onClick={() => setActiveTab('terms')}
                        className={`px-6 py-3 rounded-full text-sm md:text-sm font-bold transition-all duration-300 ${activeTab === 'terms' ? 'bg-blue-900 text-white shadow-sm' : 'text-gray-600 hover:bg-gray-100'}`}
                    >
                        Terms of Service
                    </button>
                    <button
                        onClick={() => setActiveTab('privacy')}
                        className={`px-6 py-3 rounded-full text-sm md:text-sm font-bold transition-all duration-300 ${activeTab === 'privacy' ? 'bg-blue-900 text-white shadow-sm' : 'text-gray-600 hover:bg-gray-100'}`}
                    >
                        Privacy Policy
                    </button>
                </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100 min-h-[600px]">
                {activeTab === 'terms' ? (
                    <ScrollReveal animationClass="animate-fade-in" threshold={0.1}>
                        <div className="prose max-w-none text-gray-700">
                            <h2 className="text-lg md:text-xl font-bold text-blue-900 mb-6 border-b pb-4">Terms of Service</h2>
                            <p className="mb-6 text-xs font-semibold text-gray-500">Last Updated: {new Date().toLocaleDateString()}</p>
                            
                            <h3 className="text-lg font-bold text-gray-900 mt-8 mb-3">1. Introduction</h3>
                            <p className="mb-4 text-sm md:text-sm leading-relaxed font-semibold">
                                Welcome to Querencia Micro Credit. By accessing our website, applying for a loan, or using our services, you agree to comply with and be bound by these Terms of Service. These terms constitute a legally binding agreement between you ("Borrower" or "User") and Querencia Micro Credit ("Lender", "we", "us").
                            </p>

                            <h3 className="text-lg font-bold text-gray-900 mt-8 mb-3">2. Eligibility</h3>
                            <p className="mb-4 text-sm md:text-sm leading-relaxed font-semibold">
                                To use our services, you must meet the following criteria:
                            </p>
                            <ul className="list-disc pl-5 mb-4 text-sm md:text-sm space-y-2 font-semibold">
                                <li>Be at least 18 years of age.</li>
                                <li>Be a citizen or legal resident of Ghana.</li>
                                <li>Possess a valid Ghana Card (National ID).</li>
                                <li>Have a registered mobile money wallet or bank account in your name.</li>
                            </ul>

                            <h3 className="text-lg font-bold text-gray-900 mt-8 mb-3">3. Loan Agreement & Repayment</h3>
                            <p className="mb-4 text-sm md:text-sm leading-relaxed font-semibold">
                                All loans are subject to approval based on our credit assessment criteria. By accepting a loan offer, you agree to repay the principal amount plus any accrued interest and fees by the due date. Failure to repay on time may result in:
                            </p>
                            <ul className="list-disc pl-5 mb-4 text-sm md:text-sm space-y-2 font-semibold">
                                <li>Late payment penalties as stipulated in your loan offer.</li>
                                <li>Reporting to credit bureaus in accordance with the <strong>Borrowers and Lenders Act, 2020 (Act 1052)</strong>.</li>
                                <li>Legal action to recover the outstanding debt.</li>
                            </ul>

                            <h3 className="text-lg font-bold text-gray-900 mt-8 mb-3">4. Interest Rates & Fees</h3>
                            <p className="mb-4 text-sm md:text-sm leading-relaxed font-semibold">
                                Our interest rates are competitive and transparent. All applicable fees, including processing fees and interest, will be clearly disclosed to you prior to loan disbursement. We do not charge hidden fees.
                            </p>

                            <h3 className="text-lg font-bold text-gray-900 mt-8 mb-3">5. Governing Law</h3>
                            <p className="mb-4 text-sm md:text-sm leading-relaxed font-semibold">
                                These Terms of Service shall be governed by and construed in accordance with the laws of the Republic of Ghana. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the Ghanaian courts.
                            </p>
                        </div>
                    </ScrollReveal>
                ) : (
                    <ScrollReveal animationClass="animate-fade-in" threshold={0.1}>
                        <div className="prose max-w-none text-gray-700">
                            <h2 className="text-lg md:text-xl font-bold text-blue-900 mb-6 border-b pb-4">Privacy Policy</h2>
                            <p className="mb-6 text-xs font-semibold text-gray-500">Last Updated: {new Date().toLocaleDateString()}</p>

                            <h3 className="text-lg font-bold text-gray-900 mt-8 mb-3">1. Commitment to Privacy</h3>
                            <p className="mb-4 text-sm md:text-sm leading-relaxed font-semibold">
                                At Querencia Micro Credit, we respect your privacy and are committed to protecting your personal data. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information in compliance with the <strong>Data Protection Act, 2012 (Act 843)</strong>.
                            </p>

                            <h3 className="text-lg font-bold text-gray-900 mt-8 mb-3">2. Information We Collect</h3>
                            <p className="mb-4 text-sm md:text-sm leading-relaxed font-semibold">
                                We may collect the following types of information:
                            </p>
                            <ul className="list-disc pl-5 mb-4 text-sm md:text-sm space-y-2 font-semibold">
                                <li><strong>Personal Identification:</strong> Name, date of birth, Ghana Card number, passport details.</li>
                                <li><strong>Contact Information:</strong> Phone number, email address, residential and business address.</li>
                                <li><strong>Financial Information:</strong> Bank account details, mobile money statements, income proof, and credit history.</li>
                                <li><strong>Device Data:</strong> Information about the device used to access our services for security and fraud prevention.</li>
                            </ul>

                            <h3 className="text-lg font-bold text-gray-900 mt-8 mb-3">3. How We Use Your Information</h3>
                            <p className="mb-4 text-sm md:text-sm leading-relaxed font-semibold">
                                Your data is used for the following purposes:
                            </p>
                            <ul className="list-disc pl-5 mb-4 text-sm md:text-sm space-y-2 font-semibold">
                                <li>To process loan applications and assess creditworthiness.</li>
                                <li>To disburse funds and collect repayments.</li>
                                <li>To comply with legal and regulatory obligations (e.g., KYC/AML checks).</li>
                                <li>To communicate with you regarding your account or our services.</li>
                            </ul>

                            <h3 className="text-lg font-bold text-gray-900 mt-8 mb-3">4. Data Sharing & Disclosure</h3>
                            <p className="mb-4 text-sm md:text-sm leading-relaxed font-semibold">
                                We do not sell your personal data. However, we may share your information with:
                            </p>
                            <ul className="list-disc pl-5 mb-4 text-sm md:text-sm space-y-2 font-semibold">
                                <li><strong>Credit Reference Bureaus:</strong> To report loan performance as required by law.</li>
                                <li><strong>Regulatory Authorities:</strong> Bank of Ghana and other government bodies when legally mandated.</li>
                                <li><strong>Service Providers:</strong> Third-party vendors who assist in our operations (e.g., SMS providers, payment processors) under strict confidentiality agreements.</li>
                            </ul>

                            <h3 className="text-lg font-bold text-gray-900 mt-8 mb-3">5. Your Rights</h3>
                            <p className="mb-4 text-sm md:text-sm leading-relaxed font-semibold">
                                Under the Data Protection Act, 2012 (Act 843), you have the right to access, correct, or request the deletion of your personal data held by us, subject to legal retention requirements.
                            </p>
                        </div>
                    </ScrollReveal>
                )}
            </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Termsofservice;